// extracted by mini-css-extract-plugin
module.exports = {"root":"HomeSite_root__3_ot-","logo":"HomeSite_logo__1nRb1","logo-spin":"HomeSite_logo-spin__11rJT","menu":"HomeSite_menu__1mOc5"};